import { Pipe, PipeTransform } from '@angular/core';

import { AttendeeEmailAddress } from '../../officefeed/models/upcoming-meetings.model';
import { Person } from '../models/person.model';

@Pipe({
    name: 'attendeeEmailAddressToPerson'
})
export class MeetingAttendeeToPersonPipe implements PipeTransform {
    public transform(value: AttendeeEmailAddress): Person {
        return {
            email: value.address,
            fullName: value.name
        };
    }
}
